import React from "react";
import { AdSlot } from "./ads/AdSlot";
import { UnsplashAttribution } from "../components/UnsplashAttribution";

export const Footer: React.FC = () => {
  return (
    <footer
      style={{
        padding: "0.6rem 0.9rem 0.9rem",
        display: "flex",
        flexDirection: "column",
        gap: "0.5rem"
      }}
    >
      <AdSlot
        id="footer-banner"
        label="Footer Banner"
        description="Room for a wide, low-profile banner that never covers the puzzle."
        size="banner"
      />
      <div
        className="text-xs text-muted"
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "0.75rem",
          flexWrap: "wrap",
          alignItems: "center"
        }}
      >
        <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap" }}>
          <span>Built for low-latency, browser-first puzzle races.</span>
          <span>Ads stay outside the board so gameplay is never blocked.</span>
        </div>
        <UnsplashAttribution
          photographerName="Christopher Ott"
          photographerUsername="chrisott"
          photoId="gt3qT1h86bM"
          photoTitle="Black wooden window on brown brick wall"
          compact={true}
        />
      </div>
    </footer>
  );
};


